import React, { useContext } from "react";
import { RESOURCE_NAME } from "common/authorization";
import { useExportAccountActivityMutation } from "../../../../generated/graphql";
import { useStatusToasts } from "../../../../hooks/useStatusToasts";
import { AuthContext } from "../../../Authorization/AuthContext";
import { OperationsMenuButton } from "./Button";
import MenuOption from "./MenuOption";

const AccountActivityMenu = () => {
  const { account, authorized } = useContext(AuthContext);
  const { addSuccessToast, addErrorToast } = useStatusToasts();

  const canExportActivities = authorized({
    resource: RESOURCE_NAME.ACTIVITY,
    permission: "export",
  });

  const [exportAccountActivity, { loading }] = useExportAccountActivityMutation(
    {
      onCompleted: () => {
        addSuccessToast(
          "Activity export requested. We'll email you a download link once it's ready.",
        );
      },
      onError: () => {
        addErrorToast("Failed to export account activity");
      },
    },
  );

  if (!account || !canExportActivities) {
    return null;
  }

  const handleExport = () => {
    void exportAccountActivity({
      variables: { accountId: account.id },
    });
  };

  return (
    <MenuOption
      title="Account activity"
      helperText="Request a CSV export containing every activity logged for this account."
      actionsDropdown={
        <OperationsMenuButton
          icon="download"
          text={loading ? "Exporting..." : "Export account activities"}
          onClick={handleExport}
          disabled={loading}
        />
      }
    />
  );
};

export default AccountActivityMenu;
